<template>
  <v-container v-if="teams[$route.params.team].account">
    <v2-delete-modal
      name="delete-template-modal"
      :title="
        $t('modals.deleteTemplate.title', {
          name: currentDeleteTemplate.name,
        })
      "
      :text="$t('modals.deleteTemplate.text')"
      :deleteHandler="
        () => {
          deleteTemplateModalHandler(currentDeleteTemplate);
        }
      "
    >
    </v2-delete-modal>
    <v2-delete-modal
      name="delete-contact-modal"
      :title="
        $t('modals.deleteContact.title', {
          name: $h.getNameFromClientsByUid(currentDeleteUid, contacts),
        })
      "
      :text="$t('modals.deleteContact.text')"
      :deleteHandler="
        () => {
          deleteContactModalHandler(currentDeleteUid);
        }
      "
    >
    </v2-delete-modal>
    <v2-delete-modal
      name="delete-member-modal"
      :title="
        $t('modals.deleteUser.title', {
          name: $h.getNameFromTeamMembersByUid(currentDeleteTeamMember, users),
        })
      "
      :text="$t('modals.deleteUser.text')"
      :deleteHandler="
        () => {
          deleteTeamMemberModalHandler(currentDeleteTeamMember);
        }
      "
    >
    </v2-delete-modal>
    <v2-delete-modal
      name="delete-token-modal"
      :title="
        $t('settings.dev.modals.deleteToken.title', {
          name: currentDeleteToken.name,
        })
      "
      :text="$t('settings.dev.modals.deleteToken.text')"
      :deleteHandler="
        () => {
          deleteTokenModalHandler();
        }
      "
    >
    </v2-delete-modal>
    <modal
      name="create-member"
      class="envivo-modal"
      @before-open="$h.toggleHtmlScroll"
      @before-close="$h.toggleHtmlScroll"
      transition="pop-out"
      height="auto"
      adaptive
      :maxWidth="600"
      width="90%"
      scrollable
    >
      <div class="modal-wrapper">
        <div class="modal-title">{{ $t("titles.inviteMember") }}</div>
        <div class="relative">
          <v-spinner :loading="createUserModalLoading"></v-spinner>
          <div class="modal-content">
            <form @submit.prevent>
              <v2-select
                withRequiredLabel
                :placeholder="$t('user.title')"
                v-model="gender"
                :options="genderOptions"
                optionLabel="label"
                id="gender"
                name="gender"
                v-validate="'required'"
                :error="errors.first('createTeamMember.gender')"
                :showLabels="false"
                data-vv-scope="createTeamMember"
                :data-vv-as="$t('user.title')"
              ></v2-select>
              <v-textfield
                v-model="firstname"
                name="firstname"
                required
                :placeholder="$t('user.firstName')"
                :error="errors.first('createTeamMember.firstname')"
                :data-vv-as="$t('user.firstName')"
                data-vv-scope="createTeamMember"
                v-validate="'required'"
              ></v-textfield>
              <v-textfield
                v-model="lastname"
                name="lastname"
                required
                :placeholder="$t('user.lastName')"
                :error="errors.first('createTeamMember.lastname')"
                :data-vv-as="$t('user.lastName')"
                data-vv-scope="createTeamMember"
                v-validate="'required'"
              ></v-textfield>
              <v-textfield
                v-model.trim="email"
                name="email"
                required
                :placeholder="$t('user.email')"
                :error="errors.first('createTeamMember.email')"
                :data-vv-as="$t('user.email')"
                data-vv-scope="createTeamMember"
                v-validate="'required|email'"
              ></v-textfield>
            </form>
          </div>
          <div class="modal-buttons">
            <a class="v1 simple" @click="$modal.hide('create-member')">{{ $t("actions.cancel") }}</a>
            <v-button primary @click.native="createTeamMember(true)">{{ $t("actions.inviteAndContinue") }} </v-button>
            <v-button primary @click.native="createTeamMember(false)">{{ $t("actions.inviteAndFinish") }} </v-button>
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="manage-role"
      class="envivo-modal"
      @before-open="$h.toggleHtmlScroll"
      @before-close="$h.toggleHtmlScroll"
      transition="pop-out"
      height="auto"
      adaptive
      :maxWidth="300"
      width="90%"
      scrollable
    >
      <div class="modal-wrapper">
        <div class="modal-title">{{ $t("titles.manageRole") }}</div>
        <div class="relative">
          <v-spinner :loading="manageRolesModalLoading"></v-spinner>
          <div class="modal-content">
            <form @submit.prevent>
              <div class="form-group">
                <label>Rolle auswählen</label>
                <v-radio
                  name="role"
                  :label="$t('roles.admin')"
                  @change="
                    (value) => {
                      setRole(value);
                    }
                  "
                  value="admin"
                  v-validate="'required'"
                ></v-radio>
                <v-radio
                  name="role"
                  :label="$t('roles.owner')"
                  @change="
                    (value) => {
                      setRole(value);
                    }
                  "
                  value="owner"
                  v-validate="'required'"
                ></v-radio>
                <v-radio
                  name="role"
                  :label="$t('roles.editor')"
                  @change="
                    (value) => {
                      setRole(value);
                    }
                  "
                  value="editor"
                  v-validate="'required'"
                ></v-radio>
                <v-radio
                  name="role"
                  :label="$t('roles.basic')"
                  @change="
                    (value) => {
                      setRole(value);
                    }
                  "
                  value="basic"
                  v-validate="'required'"
                ></v-radio>
                <v-radio
                  name="role"
                  :label="$t('roles.auditor')"
                  @change="
                    (value) => {
                      setRole(value);
                    }
                  "
                  value="auditor"
                  v-validate="'required'"
                ></v-radio>
                <div class="form-error">{{ errors.first("role") }}</div>
              </div>
            </form>
          </div>
          <div class="modal-buttons">
            <a class="v1 simple" @click="$modal.hide('manage-role')">{{ $t("actions.cancel") }}</a>
            <v-button primary @click.native="saveRoles()">{{ $t("actions.save") }} </v-button>
          </div>
        </div>
      </div>
    </modal>
    <v2-row>
      <v2-col col12 noSpace>
        <v2-header-bar :titles="[{ label: $t('titles.settings') }]">
          <template v-slot:tip>
            <v2-tip inside sm v-if="showTips" class="mb-2">{{ $t("tips.settings.addUsers") }} </v2-tip>
            <v2-tip inside sm v-if="showTips">{{ $t("tips.settings.subscriptions") }} </v2-tip>
          </template>
        </v2-header-bar>
      </v2-col>
    </v2-row>
    <v-row>
      <v-col class="col-12">
        <v-tabs
          :tabs="tabs"
          @setActiveTab="
            (slug) => {
              setActiveTab(slug);
            }
          "
          :active="getActiveTab()"
          :disabled="disabledTabs"
        >
          <div :slot="$t('menus.account')">
            <v-list-header simple>
              <v-list-header-cell :title="$t('titles.accountInfos')" />
            </v-list-header>
            <ul class="list">
              <v-list-item simple>
                <v-list-cell :title="$t('account.email')" size="3" />
                <v-list-cell size="2" :value="teams[$route.params.team].account.email"></v-list-cell>
                <v-list-cell emptyValue></v-list-cell>
              </v-list-item>
              <v-list-item simple>
                <v-list-cell :title="$t('account.firstName')" size="3" />
                <v-list-cell size="2">
                  <div slot="value" class="w-full">
                    <span v-if="!editFirstName && !firstNameIsLoading">{{
                      teams[$route.params.team].account.first_name
                    }}</span>
                    <v-textfield
                      simple
                      v-if="editFirstName && !firstNameIsLoading"
                      v-model="firstName"
                      v-validate="'required'"
                      data-vv-scope="firstName"
                      name="firstName"
                      :error="errors.first('firstName')"
                    >
                    </v-textfield>
                    <v-pulse-loader
                      v-if="firstNameIsLoading"
                      :loading="firstNameIsLoading"
                      :color="'#343e93'"
                      :size="'10px'"
                    ></v-pulse-loader>
                  </div>
                </v-list-cell>
                <v-list-cell
                  :button="editFirstName ? $t('actions.save') : $t('actions.edit')"
                  :onClick="
                    () => {
                      toggleFirstName();
                    }
                  "
                />
              </v-list-item>
              <v-list-item simple>
                <v-list-cell :title="$t('account.lastName')" size="3" />
                <v-list-cell size="2">
                  <div slot="value" class="w-full">
                    <span v-if="!editLastName && !lastNameIsLoading">{{
                      teams[$route.params.team].account.last_name
                    }}</span>
                    <v-textfield
                      simple
                      v-if="editLastName && !lastNameIsLoading"
                      v-model="lastName"
                      v-validate="'required'"
                      data-vv-scope="lastName"
                      name="lastName"
                      :error="errors.first('lastName')"
                    >
                    </v-textfield>
                    <v-pulse-loader
                      v-if="lastNameIsLoading"
                      :loading="lastNameIsLoading"
                      :color="'#343e93'"
                      :size="'10px'"
                    ></v-pulse-loader>
                  </div>
                </v-list-cell>
                <v-list-cell
                  :button="editLastName ? $t('actions.save') : $t('actions.edit')"
                  :onClick="
                    () => {
                      toggleLastName();
                    }
                  "
                />
              </v-list-item>
              <v-list-item simple>
                <v-list-cell :title="$t('account.locale')" size="3" />
                <v-list-cell size="2">
                  <div slot="value" class="w-full">
                    <span v-if="!editAccountLocale && !accountLocaleIsLoading">
                      {{ $h.formatLocale(teams[$route.params.team].account, $t("lang")) }}
                    </span>
                    <v2-select
                      withoutFormError
                      v-if="editAccountLocale && !accountLocaleIsLoading"
                      :placeholder="$t('placeholders.selectLocale')"
                      v-model="accountLocale"
                      :options="accountLocaleOptions"
                      optionLabel="label"
                      id="accountLocale"
                      name="accountLocale"
                      data-vv-scope="locale"
                      v-validate="'required'"
                      :error="errors.first('accountLocale')"
                      openDir="bottom"
                      :data-vv-as="$t('account.locale')"
                    ></v2-select>
                    <v-pulse-loader
                      v-if="accountLocaleIsLoading"
                      :loading="accountLocaleIsLoading"
                      :color="'#343e93'"
                      :size="'10px'"
                    ></v-pulse-loader>
                  </div>
                </v-list-cell>
                <v-list-cell
                  :button="editAccountLocale ? $t('actions.save') : $t('actions.edit')"
                  :onClick="
                    () => {
                      toggleAccountLocale();
                    }
                  "
                />
              </v-list-item>
              <v-list-item simple>
                <v-list-cell :title="$t('account.timezone')" size="3" />
                <v-list-cell size="2">
                  <div slot="value" class="w-full">
                    <span v-if="!editTimezone && !timezoneIsLoading">
                      {{ $h.formatTimezone(teams[$route.params.team].account.timezone) }}
                    </span>
                    <v2-select
                      withoutFormError
                      v-if="editTimezone && !timezoneIsLoading"
                      :placeholder="$t('placeholders.selectTimezone')"
                      v-model="timezone"
                      :options="$t('timezones')"
                      id="timezone"
                      name="timezone"
                      data-vv-scope="timezone"
                      optionLabel="label"
                      trackBy="label"
                      v-validate="'required'"
                      :error="errors.first('timezone')"
                      openDir="bottom"
                      :data-vv-as="$t('account.timezone')"
                    ></v2-select>
                    <v-pulse-loader
                      v-if="timezoneIsLoading"
                      :loading="timezoneIsLoading"
                      :color="'#343e93'"
                      :size="'10px'"
                    ></v-pulse-loader>
                  </div>
                </v-list-cell>
                <v-list-cell
                  :button="editTimezone ? $t('actions.save') : $t('actions.edit')"
                  :onClick="
                    () => {
                      toggleTimezone();
                    }
                  "
                />
              </v-list-item>
              <v-list-item simple>
                <v-list-cell :title="$t('account.notifications')" size="3" />
                <v-list-cell :value="$t('account.notifications_description')" size="2" />
                <v-list-cell class="justify-end">
                  <v-switch
                    slot="value"
                    v-model="notificationsSilenced"
                    name="notificationsSilenced"
                    @input="toggleNotificationsSilenced"
                    :labels="{ true: $t('labels.on'), false: $t('labels.off') }"
                  ></v-switch>
                </v-list-cell>
              </v-list-item>
              <v-list-item simple class="h-auto">
                <v-list-cell :title="$t('account.notificationType')" size="3" />
                <v-list-cell size="2">
                  <div slot="value" class="w-full flex items-center" :class="{ 'pt-4': editNotificationType }">
                    <span v-if="!editNotificationType && !notificationTypeIsLoading">{{
                      teams[$route.params.team].account.notification_emails
                        ? $t("notifications.summarised")
                        : $t("notifications.proActivity")
                    }}</span>
                    <v2-radio-group
                      v-if="editNotificationType && !notificationTypeIsLoading"
                      name="notificationType"
                      v-model="notificationType"
                      :options="notificationTypeOptions"
                    ></v2-radio-group>
                    <v-pulse-loader
                      v-if="notificationTypeIsLoading"
                      :loading="notificationTypeIsLoading"
                      :color="'#343e93'"
                      :size="'10px'"
                    ></v-pulse-loader>
                  </div>
                </v-list-cell>
                <v-list-cell
                  :button="editNotificationType ? $t('actions.save') : $t('actions.edit')"
                  :onClick="
                    () => {
                      toggleNotificationType();
                    }
                  "
                />
              </v-list-item>
              <v-list-item
                flexibleHeight
                simple
                v-for="(customField, index) in filteredAccountCustomFields"
                :key="index"
              >
                <v-list-cell :title="getCustomFieldTitle(customField, index)" size="3" />
                <v-list-cell
                  v-if="!editCustomField[index] && !customFieldIsLoading[index]"
                  :has_html="true"
                  :value="getCustomFieldValue(customField, index, teams[$route.params.team].account)"
                  size="2"
                  :placeholder="getCustomFieldPlaceholder(customField, index)"
                  :truncate="false"
                />
                <v-list-cell size="2" v-if="editCustomField[index] && !customFieldIsLoading[index]">
                  <div slot="value" class="w-full">
                    <v2-select
                      withoutFormError
                      :placeholder="$t('placeholders.selectCustom')"
                      v-if="editCustomField[index] && !customFieldIsLoading[index] && customField.type === 'select'"
                      v-model="customFieldValue[index]"
                      :options="customFieldSelectOptions[index]"
                      optionLabel="label"
                      :searchable="true"
                      openDir="bottom"
                    ></v2-select>
                    <v2-select
                      withoutFormError
                      :placeholder="$t('placeholders.selectCustom')"
                      v-if="
                        editCustomField[index] && !customFieldIsLoading[index] && customField.type === 'multiselect'
                      "
                      :closeOnSelect="false"
                      :clearOnSelect="false"
                      v-model="customFieldValue[index]"
                      :options="customFieldSelectOptions[index]"
                      optionLabel="label"
                      trackBy="label"
                      :multiple="true"
                      :searchable="true"
                      openDir="bottom"
                    ></v2-select>
                    <date-picker
                      class="envivo-datetimepicker"
                      v-if="editCustomField[index] && !customFieldIsLoading[index] && customField.type === 'datetime'"
                      v-model="customFieldValue[index]"
                      :lang="teams[$route.params.team].account.locale"
                      type="datetime"
                      :formatter="datetimeFormat"
                      :minute-step="1"
                      :first-day-of-week="1"
                    >
                    </date-picker>
                    <v-textfield
                      simple
                      v-if="editCustomField[index] && !customFieldIsLoading[index] && customField.type === 'input'"
                      v-model="customFieldValue[index]"
                    ></v-textfield>
                    <v-pulse-loader
                      v-if="customFieldIsLoading[index]"
                      :loading="customFieldIsLoading[index]"
                      :color="'#343e93'"
                      :size="'10px'"
                    ></v-pulse-loader>
                  </div>
                </v-list-cell>
                <v-list-cell
                  v-if="!customField.readonly"
                  :button="editCustomField[index] ? $t('actions.save') : $t('actions.edit')"
                  :onClick="
                    () => {
                      toggleCustomField(customField, index);
                    }
                  "
                />
                <v-list-cell v-if="customField.readonly" emptyValue />
              </v-list-item>
            </ul>
          </div>
          <div :slot="$t('menus.team')">
            <v-row>
              <v-col class="col-12 px-0">
                <v-list-header simple>
                  <v-list-header-cell :title="$t('titles.teamInfo')" />
                </v-list-header>
                <ul class="list">
                  <v-list-item simple>
                    <v-list-cell :title="$t('team.slug')" size="3" />
                    <v-list-cell :value="teams[$route.params.team].account.team.slug" size="2" />
                    <v-list-cell emptyValue></v-list-cell>
                  </v-list-item>
                  <v-list-item simple>
                    <v-list-cell :title="$t('team.name')" size="3" />
                    <v-list-cell size="2">
                      <div slot="value" class="w-full">
                        <span v-if="!editTeamName && !teamNameIsLoading">{{
                          teams[$route.params.team].account.team.name
                        }}</span>
                        <v-textfield
                          simple
                          v-if="editTeamName && !teamNameIsLoading"
                          v-model="teamName"
                          v-validate="'required'"
                          data-vv-scope="teamname"
                          name="teamName"
                          :error="errors.first('teamname.teamName')"
                        >
                        </v-textfield>
                        <v-pulse-loader
                          v-if="teamNameIsLoading"
                          :loading="teamNameIsLoading"
                          :color="'#343e93'"
                          :size="'10px'"
                        ></v-pulse-loader>
                      </div>
                    </v-list-cell>
                    <v-list-cell
                      :btnActive="teams[$route.params.team].account.role.includes('owner')"
                      :button="editTeamName ? $t('actions.save') : $t('actions.edit')"
                      :onClick="
                        () => {
                          toggleTeamName();
                        }
                      "
                    />
                  </v-list-item>
                  <v-list-item simple>
                    <v-list-cell :title="$t('team.domain')" size="3" />
                    <v-list-cell size="2">
                      <div slot="value" class="w-full">
                        <span v-if="!editTeamDomain && !teamDomainIsLoading">{{
                          teams[$route.params.team].account.team.url
                        }}</span>
                        <v-textfield
                          simple
                          v-if="editTeamDomain && !teamDomainIsLoading"
                          v-model="teamDomain"
                          v-validate="'required'"
                          data-vv-scope="teamdomain"
                          name="teamDomain"
                          :error="errors.first('teamdomain.teamDomain')"
                        >
                        </v-textfield>
                        <v-pulse-loader
                          v-if="teamDomainIsLoading"
                          :loading="teamDomainIsLoading"
                          :color="'#343e93'"
                          :size="'10px'"
                        ></v-pulse-loader>
                      </div>
                    </v-list-cell>
                    <v-list-cell
                      :btnActive="teams[$route.params.team].account.role.includes('owner')"
                      :button="editTeamDomain ? $t('actions.save') : $t('actions.edit')"
                      :onClick="
                        () => {
                          toggleTeamDomain();
                        }
                      "
                    />
                  </v-list-item>
                </ul>
              </v-col>
            </v-row>
            <v-row
              v-if="
                teamsSettings[$route.params.team] && teamsSettings[$route.params.team].listsSettings.users.filterActive
              "
            >
              <v-col stretch>
                <v-card custom class="p-6">
                  <div slot="content" class="flex flex-col sm:flex-row w-full justify-between">
                    <div>
                      <div class="text-grey-lavender mb-1">
                        {{ $t("filters.results") }}
                      </div>
                      <h6>
                        {{
                          $tc(
                            "filters.usersResult",
                            teamsSettings[$route.params.team].listsSettings.users.pagination.total,
                            {
                              result: teamsSettings[$route.params.team].listsSettings.users.pagination.total,
                            }
                          )
                        }}
                      </h6>
                    </div>
                    <v-button class="mt-4 sm:mt-0 mr-2" attention @click.native="resetFilters(setUsersFilters)">
                      {{ $t("filters.resetFilter") }}
                    </v-button>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="col-12 px-0">
                <v-list-header simple>
                  <v-list-header-cell :title="$t('titles.users')" />
                  <v-list-header-cell
                    :simpleLink="$t('actions.createNewTeamMember')"
                    :onClick="openCreateTeamMemberModal"
                  />
                </v-list-header>
                <v-list-header complex>
                  <v-list-header-cell emptyIcon />
                  <v-list-header-cell
                    size="2"
                    :showAs="$t('user.name')"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="sortMainColDropdown"
                  />
                  <v-list-header-cell
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.users.showAs.firstCol.label)"
                    :size="teamsSettings[$route.params.team].listsSettings.users.showAs.firstCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsFirstColDropdown"
                  />
                  <v-list-header-cell
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.users.showAs.secondCol.label)"
                    tabletHidden
                    :size="teamsSettings[$route.params.team].listsSettings.users.showAs.secondCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsSecondColDropdown"
                  />
                  <v-list-header-cell
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.users.showAs.thirdCol.label)"
                    dropdownRight
                    :size="teamsSettings[$route.params.team].listsSettings.users.showAs.thirdCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsThirdColDropdown"
                  />
                  <v-list-header-cell
                    :mobile="$t('actions.sort')"
                    :mobileDropdownUid="$h.createUniqueUid()"
                    :mobileDropdown="mobileDropdown"
                  />
                  <v-list-header-cell
                    filter
                    dropdownRight
                    multiselect
                    :columns="1"
                    :filterActive="teamsSettings[$route.params.team].listsSettings.users.filterActive"
                    :filterDropdownUid="$h.createUniqueUid()"
                    :filterDropdown="filterDropdown"
                  />
                </v-list-header>
                <ul class="list" v-if="!customLoading">
                  <v-list-item complex hover v-for="user in users" :key="user.uid">
                    <v-list-cell icon="Icon=user.svg" iconColor="#5057AF" />
                    <v-list-cell :title="$h.formatName(user)" size="2" :mobileSubtitle="user.email" />
                    <v-list-cell
                      :size="teamsSettings[$route.params.team].listsSettings.users.showAs.firstCol.size"
                      :value="
                        $h.formatValue(
                          teamsSettings[$route.params.team].listsSettings.users.showAs.firstCol.format,
                          user[teamsSettings[$route.params.team].listsSettings.users.showAs.firstCol.key],
                          teams[$route.params.team].account.timezone
                        )
                      "
                    />
                    <v-list-cell
                      :size="teamsSettings[$route.params.team].listsSettings.users.showAs.secondCol.size"
                      tabletHidden
                      :value="
                        $h.formatValue(
                          teamsSettings[$route.params.team].listsSettings.users.showAs.secondCol.format,
                          user[teamsSettings[$route.params.team].listsSettings.users.showAs.secondCol.key],
                          teams[$route.params.team].account.timezone
                        )
                      "
                    />
                    <v-list-cell
                      :size="teamsSettings[$route.params.team].listsSettings.users.showAs.thirdCol.size"
                      :value="
                        $h.formatValue(
                          teamsSettings[$route.params.team].listsSettings.users.showAs.thirdCol.format,
                          user[teamsSettings[$route.params.team].listsSettings.users.showAs.thirdCol.key],
                          teams[$route.params.team].account.timezone
                        )
                      "
                    />
                    <v-list-cell
                      iconDropdown
                      grey
                      icon="Icon=more-horizontal.svg"
                      iconColor="#5057af"
                      :dropdownData="setTeamMembersDropdownOptions"
                      :dropdownUid="$h.createUniqueUid()"
                      :dropdownValue="user"
                      v-if="user.uid !== teams[$route.params.team].account.uid"
                    />
                    <v-list-cell
                      style="width: 65px; height: 100%; flex: none"
                      v-if="user.uid === teams[$route.params.team].account.uid"
                    />
                  </v-list-item>
                  <v-list-item v-if="users && !users.length">
                    <v-list-cell :value="$t('placeholders.noUsers')"></v-list-cell>
                  </v-list-item>
                </ul>
                <v-list-pagination
                  :currentPage="teamsSettings[$route.params.team].listsSettings.users.pagination.page"
                  :showPerPage="teamsSettings[$route.params.team].listsSettings.users.pagination.perPage"
                  :totalPages="teamsSettings[$route.params.team].listsSettings.users.pagination.lastPage"
                  :apiCall="
                    (page, perPage) => {
                      changeUsersPage(page, perPage);
                    }
                  "
                >
                </v-list-pagination>
              </v-col>
            </v-row>
            <v-row
              v-if="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')"
              id="billing"
            >
              <v-col class="col-12 px-0">
                <label>{{ $t("labels.billing") }}</label>
                <p>{{ $t("texts.billing.note") }}</p>
                <ul class="pl-4 py-4">
                  <li class="pb-2" style="list-style: disc">
                    {{ $t("texts.billing.accountInfo") }}
                  </li>
                  <li class="pb-2" style="list-style: disc">
                    {{ $t("texts.billing.billingAddress") }}
                  </li>
                  <li class="pb-2" style="list-style: disc">
                    {{ $t("texts.billing.paymentMethod") }}
                  </li>
                  <li class="pb-2" style="list-style: disc">
                    {{ $t("texts.billing.buyingHistory") }}
                  </li>
                </ul>
                <v-button
                  primary
                  @click.native="openBilling"
                  :active="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')"
                  >{{ $t("actions.manageSubscription") }}
                </v-button>
                <p class="text-sm mt-4" v-html="$t('texts.teamSubscription.note')"></p>
              </v-col>
            </v-row>
            <v-row v-if="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')">
              <v-col class="col-12 px-0">
                <label class="text-danger">{{ $t("actions.deleteTeam") }}</label>
                <label class="text-18">{{ $t("labels.requestPin") }}</label>
                <p>
                  {{ $t("texts.getDeleteTeamPin") }}
                </p>
                <v-button
                  primary
                  @click.native="getDeleteTeamPin"
                  class="mb-12"
                  :active="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')"
                >
                  {{ $t("actions.getDeleteTeamPin") }}
                </v-button>
                <label class="text-18">{{ $t("labels.enterPinAndPw") }}</label>
                <p>
                  {{ $t("texts.deleteTeam") }}
                </p>
                <v-col class="col-6 px-0">
                  <v-textfield
                    :label="$t('labels.deleteTeamPin')"
                    v-model="pin"
                    v-validate="'required'"
                    name="pin"
                    :data-vv-as="$t('team.pin')"
                    :error="errors.first('pin')"
                  ></v-textfield>
                  <v-textfield
                    :label="$t('labels.deleteTeamPassword')"
                    v-model="password"
                    type="password"
                    v-validate="'required'"
                    name="password"
                    :data-vv-as="$t('team.password')"
                    :error="errors.first('password')"
                  ></v-textfield>
                </v-col>
                <v-button
                  danger
                  @click.native="deleteThisTeam"
                  :active="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')"
                >
                  {{ $t("actions.deleteTeam") }}
                </v-button>
              </v-col>
            </v-row>
          </div>
          <div :slot="$t('menus.contacts')">
            <v-row v-if="contacts && teamsSettings[$route.params.team]">
              <v-col class="col-12 p-0">
                <v-list-header simple>
                  <v-list-header-cell :title="$t('titles.contacts')" />
                  <v-list-header-cell :link="$t('actions.createNewContact')" :route="{ name: 'createContact' }" />
                </v-list-header>
                <v-list-header complex>
                  <v-list-header-cell emptyIcon />
                  <v-list-header-cell
                    size="3"
                    :showAs="$t('contact.name')"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="sortMainColDropdown"
                  />
                  <v-list-header-cell
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.contacts.showAs.firstCol.label)"
                    :size="teamsSettings[$route.params.team].listsSettings.contacts.showAs.firstCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsFirstColDropdown"
                  />
                  <v-list-header-cell
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.contacts.showAs.secondCol.label)"
                    tabletHidden
                    :size="teamsSettings[$route.params.team].listsSettings.contacts.showAs.secondCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsSecondColDropdown"
                  />
                  <v-list-header-cell
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.contacts.showAs.thirdCol.label)"
                    dropdownRight
                    :size="teamsSettings[$route.params.team].listsSettings.contacts.showAs.thirdCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsThirdColDropdown"
                  />
                  <v-list-header-cell
                    :mobile="$t('actions.sort')"
                    :mobileDropdownUid="$h.createUniqueUid()"
                    :mobileDropdown="mobileDropdown"
                  />
                  <v-list-header-cell emptyIcon />
                  <!--<v-list-header-cell-->
                  <!--  filter-->
                  <!--  dropdownRight-->
                  <!--  multiselect-->
                  <!--  :filterActive="teamsSettings[$route.params.team].listsSettings.contacts.filterActive"-->
                  <!--  :filterDropdownUid="$h.createUniqueUid()"-->
                  <!--  :filterDropdown="filterDropdown"-->
                  <!--/>-->
                </v-list-header>
                <ul class="list">
                  <router-link
                    :to="{ name: 'Contact', params: { uid: contact.uid } }"
                    v-for="contact in contacts"
                    :key="contact.uid"
                  >
                    <v-list-item complex hover>
                      <contact-list-image
                        :currentContact="contact"
                        :currentProfileImage="contact.image"
                      ></contact-list-image>
                      <v-list-cell :title="$h.formatName(contact)" size="3" :mobileSubtitle="contact.email" />
                      <v-list-cell
                        :size="teamsSettings[$route.params.team].listsSettings.contacts.showAs.firstCol.size"
                        :value="
                          $h.formatValue(
                            teamsSettings[$route.params.team].listsSettings.contacts.showAs.firstCol.format,
                            contact[teamsSettings[$route.params.team].listsSettings.contacts.showAs.firstCol.key],
                            teams[$route.params.team].account.timezone
                          )
                        "
                      />
                      <v-list-cell
                        :size="teamsSettings[$route.params.team].listsSettings.contacts.showAs.secondCol.size"
                        tabletHidden
                        :value="
                          $h.formatValue(
                            teamsSettings[$route.params.team].listsSettings.contacts.showAs.secondCol.format,
                            contact[teamsSettings[$route.params.team].listsSettings.contacts.showAs.secondCol.key],
                            teams[$route.params.team].account.timezone
                          )
                        "
                      />
                      <v-list-cell
                        :size="teamsSettings[$route.params.team].listsSettings.contacts.showAs.thirdCol.size"
                        :value="
                          $h.formatValue(
                            teamsSettings[$route.params.team].listsSettings.contacts.showAs.thirdCol.format,
                            contact[teamsSettings[$route.params.team].listsSettings.contacts.showAs.thirdCol.key],
                            teams[$route.params.team].account.timezone
                          )
                        "
                      />
                      <v-list-cell
                        iconDropdown
                        grey
                        icon="Icon=more-horizontal.svg"
                        iconColor="#5057af"
                        :dropdownData="contactDropdownOptions"
                        :dropdownUid="$h.createUniqueUid()"
                        :dropdownValue="contact"
                      />
                    </v-list-item>
                    <v-list-item v-if="!contacts.length">
                      <v-list-cell :value="$t('placeholders.noContacts')"></v-list-cell>
                    </v-list-item>
                  </router-link>
                </ul>
                <v-list-pagination
                  :currentPage="teamsSettings[$route.params.team].listsSettings.contacts.pagination.page"
                  :showPerPage="teamsSettings[$route.params.team].listsSettings.contacts.pagination.perPage"
                  :totalPages="teamsSettings[$route.params.team].listsSettings.contacts.pagination.lastPage"
                  :apiCall="
                    (page, perPage) => {
                      changeContactsPage(page, perPage);
                    }
                  "
                >
                </v-list-pagination>
              </v-col>
            </v-row>
          </div>
          <div :slot="$t('menus.templates')" v-if="teamCan('template-builder')">
            <v2-row class="flex items-center justify-between">
              <v2-col noSpaceX>
                <h3>{{ $t("settings.templates.titles.templates") }}</h3>
              </v2-col>
              <v2-col noSpaceX>
                <v2-button v2Primary md @click.native="$goTo('createTemplate')">
                  <v2-icon
                    :data="require('@icon/Icon=plus.svg')"
                    color="currentColor"
                    height="18px"
                    width="auto"
                    class="mr-1"
                  ></v2-icon
                  >{{ $t("settings.templates.actions.createTemplate") }}
                </v2-button>
              </v2-col>
            </v2-row>
            <div class="-mx-4">
              <v2-row v-if="templates && teamsSettings[$route.params.team]">
                <v2-col v-for="template in templates" :key="template.uid">
                  <div class="border border-v2-neutral-300">
                    <router-link :to="{ name: 'Template', params: { uid: template.uid, tab: '_general' } }">
                      <div
                        style="width: 235px; height: 235px"
                        class="text-v2-neutral-400 flex items-center justify-center"
                      >
                        <v2-icon
                          v-if="!template.thumbnail.sm"
                          :data="require('@icon/Icon=platzhalter.svg')"
                          original
                          style="stroke: none"
                          width="100%"
                          height="auto"
                        ></v2-icon>
                        <img v-if="template.thumbnail.sm" :src="template.thumbnail.sm" alt="Template thumbnail" />
                      </div>
                    </router-link>
                    <div class="flex justify-between border-t border-v2-neutral-300 p-2">
                      <router-link :to="{ name: 'Template', params: { uid: template.uid, tab: '_general' } }">
                        <div class="truncate" style="width: 200px">
                          {{ template.name }}
                        </div>
                      </router-link>
                      <div class="relative">
                        <div
                          class="cursor-pointer"
                          @click.stop="$eventbus.$emit('toggleDropdown', templateDropdownUid + '_' + template.uid)"
                        >
                          <v2-icon :data="require('@icon/Icon=more-horizontal.svg')" color="#5057AF"></v2-icon>
                        </div>
                        <v2-dropdown
                          :dropdownUid="templateDropdownUid + '_' + template.uid"
                          :dropdownData="setDropdownData(template)"
                          :value="template"
                          width="auto"
                          right="0"
                          simple
                        ></v2-dropdown>
                      </div>
                    </div>
                  </div>
                </v2-col>
              </v2-row>
            </div>
          </div>
          <div :slot="$t('menus.forms')">
            <v-row>
              <v-col class="col-12 p-0">
                <v-list-header complex>
                  <v-list-header-cell size="2" :title="$t('settings.forms.labels.forms')" />
                  <v-list-header-cell size="1" :title="$t('settings.forms.labels.version')" />
                  <v-list-header-cell size="1" :title="$t('settings.forms.labels.submissions')" />
                  <v-list-header-cell size="3" :title="$t('settings.forms.labels.description')" />
                  <v-list-header-cell emptyIcon />
                </v-list-header>
                <ul class="list" v-if="forms">
                  <router-link
                    :to="{
                      name: 'Form',
                      params: {
                        uid: form.uid,
                      },
                    }"
                    v-for="form in forms"
                    :key="form.uid"
                  >
                    <v-list-item complex hover>
                      <v-list-cell :title="form.name" size="2" />
                      <v-list-cell size="1" :value="form.version" />
                      <v-list-cell size="1" :value="form.responses_count.toString()" />
                      <v-list-cell size="3" :value="form.description" />
                      <v-list-cell
                        size="1"
                        icon="Icon=download.svg"
                        iconColor="#5057af"
                        iconLink
                        :onClick="
                          () => {
                            exportFormSubmission(form);
                          }
                        "
                      />
                    </v-list-item>
                    <v-list-item v-if="!(forms && forms.length)">
                      <v-list-cell :value="$t('placeholders.noForms')"></v-list-cell>
                    </v-list-item>
                  </router-link>
                </ul>
              </v-col>
            </v-row>
          </div>
          <div :slot="$t('menus.imports')">
            <v-row>
              <v-col class="col-12 p-0">
                <v-list-header simple>
                  <v-list-header-cell :title="$t('titles.imports')" />
                  <v-list-header-cell
                    :link="$t('labels.newImport')"
                    :disabledLink="!teamCan('imports')"
                    :disabledHandler="
                      () => {
                        $h.showSubscriptionErrorModal(
                          $modal,
                          teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')
                        );
                      }
                    "
                    :route="{ name: 'createImport' }"
                  />
                </v-list-header>
                <v-list-header complex>
                  <v-list-header-cell emptyIcon />
                  <v-list-header-cell
                    size="2"
                    :showAs="$t('imports.title')"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="sortMainColDropdown"
                  />
                  <v-list-header-cell
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.imports.showAs.firstCol.label)"
                    :size="teamsSettings[$route.params.team].listsSettings.imports.showAs.firstCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsFirstColDropdown"
                  />
                  <v-list-header-cell
                    dropdownRight
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.imports.showAs.secondCol.label)"
                    tabletHidden
                    :size="teamsSettings[$route.params.team].listsSettings.imports.showAs.secondCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsSecondColDropdown"
                  />
                </v-list-header>
                <ul class="list" v-if="imports">
                  <router-link
                    :to="{ name: 'Import', params: { uid: cimport.uid } }"
                    v-for="cimport in imports"
                    :key="cimport.uid"
                  >
                    <v-list-item complex hover>
                      <v-list-cell icon="Icon=folder.svg" iconFill iconColor="#5057AF" />
                      <v-list-cell :title="cimport.title" size="2" />
                      <v-list-cell
                        :size="teamsSettings[$route.params.team].listsSettings.imports.showAs.firstCol.size"
                        :value="
                          $h.formatValue(
                            teamsSettings[$route.params.team].listsSettings.imports.showAs.firstCol.format,
                            cimport[teamsSettings[$route.params.team].listsSettings.imports.showAs.firstCol.key],
                            teams[$route.params.team].account.timezone
                          )
                        "
                      />
                      <v-list-cell
                        :size="teamsSettings[$route.params.team].listsSettings.imports.showAs.secondCol.size"
                        :value="
                          $h.formatValue(
                            teamsSettings[$route.params.team].listsSettings.imports.showAs.secondCol.format,
                            cimport[teamsSettings[$route.params.team].listsSettings.imports.showAs.secondCol.key],
                            teams[$route.params.team].account.timezone
                          )
                        "
                      />
                    </v-list-item>
                  </router-link>
                  <v-list-item v-if="!(imports && imports.length)">
                    <v-list-cell :value="$t('placeholders.noImports')"></v-list-cell>
                  </v-list-item>
                </ul>
                <v-list-pagination
                  :currentPage="teamsSettings[$route.params.team].listsSettings.imports.pagination.page"
                  :totalPages="teamsSettings[$route.params.team].listsSettings.imports.pagination.lastPage"
                  :showPerPage="teamsSettings[$route.params.team].listsSettings.imports.pagination.perPage"
                  :apiCall="
                    (page, perPage) => {
                      changeImportsPage(page, perPage);
                    }
                  "
                >
                </v-list-pagination>
              </v-col>
            </v-row>
          </div>
          <div :slot="$t('menus.developer')">
            <v2-row class="flex-col">
              <v2-col col12 noSpace noSpaceX class="mb-12" style="max-width: 685px">
                <h3 class="heading-3">
                  {{ $t("settings.dev.headings.main") }}
                </h3>
                <div class="flex items-center">
                  <v2-textfield
                    small
                    :value="teams[$route.params.team].account.team.links.self"
                    :label="$t('settings.dev.labels.apiUrl')"
                    disabled
                    class="cursor-text"
                  ></v2-textfield>
                  <v2-button
                    v2Secondary
                    small
                    class="ml-18px mb-1.5"
                    @click.native="copyToClipboard(teams[$route.params.team].account.team.links.self, 'api')"
                    >{{ $t("actions.copy") }}
                  </v2-button>
                </div>
                <p class="paragraph-2">
                  {{ $t("settings.dev.texts.main") }}
                </p>
                <hr />
              </v2-col>
              <v2-col
                style="max-width: 575px"
                col12
                noSpace
                noSpaceX
                v-if="!showCreateToken && !showCreatedToken && !showEditToken"
              >
                <h4 class="heading-4 flex justify-between items-center">
                  <div>{{ $t("settings.dev.headings.overview") }}</div>
                  <v2-button v2Primary @click.native="showCreateToken = true">
                    <div style="width: 24px">
                      <v2-icon
                        :data="require('@icon/Icon=plus.svg')"
                        color="#fff"
                        height="16px"
                        width="auto"
                        class="mr-2"
                      ></v2-icon>
                    </div>
                    {{ $t("settings.dev.actions.createNewToken") }}
                  </v2-button>
                </h4>
                <ul>
                  <v2-list-item simple striped v-for="(token, index) in userAccessTokens" :key="token.access_key">
                    <v2-list-cell class="flex-1">
                      <template v-slot:value>
                        {{ token.name }}
                      </template>
                    </v2-list-cell>
                    <v2-list-cell class="flex-1">
                      <template v-slot:value>
                        {{ token.access_key }}
                      </template>
                    </v2-list-cell>
                    <v2-list-cell noFlex class="relative">
                      <template v-slot:value>
                        <div
                          class="cursor-pointer"
                          @click.stop="$eventbus.$emit('toggleDropdown', actionsDropdownUid + '_' + index)"
                        >
                          <v2-icon :data="require('@icon/Icon=more-horizontal.svg')" color="#5057AF"></v2-icon>
                        </div>
                        <v2-dropdown
                          :dropdownUid="actionsDropdownUid + '_' + index"
                          :dropdownData="userAccessTokenDropdownData"
                          :value="token"
                          width="auto"
                          right="0"
                          simple
                        ></v2-dropdown>
                      </template>
                    </v2-list-cell>
                  </v2-list-item>
                </ul>
              </v2-col>
              <v2-col style="max-width: 575px" col12 noSpace noSpaceX v-if="showCreateToken || showCreatedToken">
                <h4 class="heading-4">
                  {{ $t("settings.dev.headings.createNewToken") }}
                </h4>
                <v2-textfield
                  fullWidth
                  small
                  :disabled="showCreatedToken"
                  v-model="tokenName"
                  name="token"
                  :label="$t('settings.dev.labels.tokenName')"
                  :placeholder="$t('settings.dev.placeholders.enterTokenName')"
                  v-validate="'required'"
                  :error="errors.first('createUserAccessToken.token')"
                  data-vv-scope="createUserAccessToken"
                  :data-vv-as="$t('settings.dev.labels.tokenName')"
                ></v2-textfield>
                <v2-button v2Primary small fitWidth @click.native="createNewToken" :active="!showCreatedToken">
                  <div class="flex" style="width: 24px">
                    <v2-icon
                      :data="require('@icon/Icon=plus.svg')"
                      color="currentColor"
                      height="16px"
                      width="auto"
                      class="mr-2"
                    ></v2-icon>
                  </div>
                  {{ $t("settings.dev.actions.generateKey") }}
                </v2-button>
                <div v-if="showCreatedToken" class="mt-30px">
                  <div class="flex items-center">
                    <v2-textfield
                      small
                      :value="lastCreatedToken.access_key"
                      :label="$t('settings.dev.labels.accessKey')"
                      disabled
                      class="cursor-text"
                    ></v2-textfield>
                    <v2-button
                      v2Secondary
                      small
                      class="ml-18px mb-1.5"
                      @click.native="copyToClipboard(lastCreatedToken.access_key, 'key')"
                      >{{ $t("actions.copy") }}
                    </v2-button>
                  </div>
                  <div class="flex items-center">
                    <v2-textfield
                      small
                      :value="lastCreatedToken.access_secret"
                      :label="$t('settings.dev.labels.accessSecret')"
                      disabled
                      class="cursor-text"
                    ></v2-textfield>
                    <v2-button
                      v2Secondary
                      small
                      class="ml-18px mb-1.5"
                      @click.native="copyToClipboard(lastCreatedToken.access_secret, 'secret')"
                      >{{ $t("actions.copy") }}
                    </v2-button>
                  </div>
                  <v2-button v2Primary sm @click.native="returnToTokenList()">{{ $t("actions.finish") }} </v2-button>
                </div>
              </v2-col>
              <v2-col col12 noSpace noSpaceX style="max-width: 575px" v-if="showEditToken">
                <h4 class="heading-4">
                  {{ $t("settings.dev.headings.editToken") }}
                </h4>
                <v2-textfield
                  fullWidth
                  focussed
                  small
                  name="token"
                  :label="$t('settings.dev.labels.tokenName')"
                  :placeholder="$t('settings.dev.placeholders.enterTokenName')"
                  v-model="editTokenName"
                  v-validate="'required'"
                  :error="errors.first('editUserAccessToken.token')"
                  data-vv-scope="editUserAccessToken"
                  :data-vv-as="$t('settings.dev.labels.tokenName')"
                ></v2-textfield>
                <v2-button v2Primary small @click.native="updateToken">{{ $t("actions.save") }} </v2-button>
              </v2-col>
            </v2-row>
          </div>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as clipboard from "clipboard-polyfill";
import { mapGetters, mapActions } from "vuex";
import listSettings from "@/mixins/listSettings.js";
import users from "@/mixins/dropdowns/users.js";
import templates from "@/mixins/dropdowns/templates.js";
import contacts from "@/mixins/dropdowns/contacts.js";
import imports from "@/mixins/dropdowns/imports.js";
import customFields from "@/mixins/customFields.js";
import teamAbilities from "@/mixins/teamAbilities.js";
import $lang from "@/assets/js/lang.js";
import ContactListImage from "@/views/partials/ContactListImage.vue";

export default {
  name: "Settings",
  mixins: [listSettings, templates, contacts, imports, customFields, teamAbilities, users],
  components: {
    ContactListImage,
  },
  data() {
    return {
      tabs: [
        this.$t("menus.account"),
        this.$t("menus.team"),
        this.$t("menus.contacts"),
        this.$t("menus.imports"),
        this.$t("menus.developer"),
      ],
      actionsDropdownUid: this.$h.createUniqueUid(),
      userAccessTokenDropdownData: [
        {
          name: this.$t("settings.dev.actions.editToken"),
          method: (value) => {
            this.setEditUserAccessToken(value);
          },
        },
        {
          name: this.$t("settings.dev.actions.deleteToken"),
          method: (value) => {
            this.openDeleteTokenModal(value);
          },
        },
      ],
      templateDropdownUid: this.$h.createUniqueUid(),
      templateDropdownData: [
        {
          name: this.$t("actions.duplicateTemplate"),
          method: (template) => {
            this.duplicateTemplate(template);
          },
        },
      ],
      tokenName: "",
      showCreateToken: false,
      showCreatedToken: false,
      showEditToken: false,
      lastCreatedToken: {},
      editToken: {},
      editTokenName: "",
      currentDeleteToken: {},
      currentDeleteTemplate: {},
      firstname: "",
      lastname: "",
      email: "",
      gender: null,
      genderOptions: [
        { label: this.$t("user.female"), value: "f" },
        { label: this.$t("user.male"), value: "m" },
      ],
      currentDeleteUid: null,
      disabledTabs: [],
      filterDropdown: null,
      mobileDropdown: null,
      sortMainColDropdown: null,
      showAsFirstColDropdown: null,
      showAsSecondColDropdown: null,
      showAsThirdColDropdown: null,
      editFirstName: false,
      firstNameIsLoading: false,
      firstName: "",
      editLastName: false,
      lastNameIsLoading: false,
      lastName: "",
      editAccountLocale: false,
      accountLocaleIsLoading: false,
      accountLocale: null,
      accountLocaleOptions: $lang.accountLocaleOptions,
      editTimezone: false,
      timezoneIsLoading: false,
      timezone: null,
      notificationsSilenced: null,
      notificationTypeOptions: [
        {
          label: this.$t("notifications.proActivity"),
          value: false,
        },
        {
          label: this.$t("notifications.summarised"),
          value: true,
        },
      ],
      editNotificationType: false,
      notificationTypeIsLoading: false,
      notificationType: "",
      currentContactImagesPreviews: [],
      contactDropdownOptions: [
        {
          options: [
            {
              label: this.$t("actions.edit"),
              method: (contact) => {
                this.$goTo("editContact", { uid: contact.uid });
              },
              doNotShowActiveState: true,
            },
            {
              label: this.$t("actions.delete"),
              method: (contact) => {
                this.showDeleteModal(contact.uid);
              },
              color: "text-danger",
              doNotShowActiveState: true,
            },
          ],
        },
      ],
      teamName: "",
      editTeamName: false,
      teamNameIsLoading: false,
      teamDomain: "",
      editTeamDomain: false,
      teamDomainIsLoading: false,
      password: null,
      pin: null,
      createUserModalLoading: false,
      currentDeleteTeamMember: null,
      currentPageParams: {},
      manageRolesModalLoading: false,
      currentManageRolesMember: null,
      role: "",
      chargebeeInstance: null,
      searchQuery: "",
    };
  },
  created() {
    const vm = this;
    if (this.isFormsEnabled) {
      let importTabIdx = this.tabs.findIndex(function (tabLabel, idx) {
        if (tabLabel === vm.$t("menus.imports")) {
          return idx;
        }
      });
      this.tabs.splice(importTabIdx, 0, this.$t("menus.forms"));
    }
    if (this.$route.params.tab === "team") {
      this.initChargebee();
      this.teamName = this.teams[this.$route.params.team].account.team.name;
      this.teamDomain = this.teams[this.$route.params.team].account.team.url;
      this.filterDropdown = this.usersDropdownData.filterDropdown;
      this.mobileDropdown = this.usersDropdownData.mobileDropdown;
      this.sortMainColDropdown = this.usersDropdownData.sortMainColDropdown;
      this.showAsFirstColDropdown = this.usersDropdownData.showAsFirstColDropdown;
      this.showAsSecondColDropdown = this.usersDropdownData.showAsSecondColDropdown;
      this.showAsThirdColDropdown = this.usersDropdownData.showAsThirdColDropdown;
    } else if (this.$route.params.tab === "contacts") {
      this.filterDropdown = this.contactsDropdownData.filterDropdown;
      this.mobileDropdown = this.contactsDropdownData.mobileDropdown;
      this.sortMainColDropdown = this.contactsDropdownData.sortMainColDropdown;
      this.showAsFirstColDropdown = this.contactsDropdownData.showAsFirstColDropdown;
      this.showAsSecondColDropdown = this.contactsDropdownData.showAsSecondColDropdown;
      this.showAsThirdColDropdown = this.contactsDropdownData.showAsThirdColDropdown;
    } else if (this.$route.params.tab === "imports") {
      this.sortMainColDropdown = this.importDropdownData.sortMainColDropdown;
      this.showAsFirstColDropdown = this.importDropdownData.showAsFirstColDropdown;
      this.showAsSecondColDropdown = this.importDropdownData.showAsSecondColDropdown;
    }
    this.loadPageData();
    if (this.teamCan("template-builder")) this.tabs.splice(3, 0, this.$t("menus.templates"));
  },
  mounted() {
    if (this.$route.params.tab === "team" && this.$route.params.scroll) {
      this.$scrollTo("#billing", 500, { offset: 200 });
    }

    this.$eventbus.$on("reloadTemplates", this.loadPageData);
  },
  methods: {
    ...mapActions([
      "getUsers",
      "getTeamLanguages",
      "getTeamTemplates",
      "getAuthAccount",
      "editAuthAccount",
      "getTeamThemes",
      "setListsSettings",
      "getTeamTemplateBuilderSession",
      "getTeamContacts",
      "getContactImagePreview",
      "deleteContact",
      "getImports",
      "editTeam",
      "postDeleteTeam",
      "deleteTeam",
      "logout",
      "createUser",
      "deleteUser",
      "inviteUser",
      "getUserSubscription",
      "editUser",
      "postUserSubscription",
      "deleteUserSubscription",
      "editUserRoles",
      "getTeamSubscription",
      "postTeamSubscription",
      "templateApiRequest",
      "getUserAccessTokens",
      "createUserAccessToken",
      "editUserAccessToken",
      "deleteUserAccessToken",
      "getForms",
      "getFormSubmissions",
      "getProjectList",
      "getClientList",
      "getForm",
      "templateApiRequest",
      "exportFormResponses",
    ]),
    loadPageData() {
      const vm = this;
      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      if (vm.$route.params.tab === "account") {
        vm.getAuthAccount({ team: vm.$router.currentRoute.params.team }).then(() => {
          vm.setEditableCustomFields(
            vm.teams[vm.$route.params.team].accountCustomFields,
            vm.teams[vm.$route.params.team].account
          );
          vm.setAccountModels();
          vm.getTeamLanguages()
            .then(() => {
              vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
            })
            .catch(() => {
              vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
            });
        });
      } else if (vm.$route.params.tab === "team") {
        let params = {
          page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.page,
          per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.perPage,
          order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.col,
          order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.dir,
        };
        vm.getUsers({
          setListsSettings: true,
          params,
        })
          .then(() => {
            vm.initSort("users");
            vm.initShowAs("users");
            vm.setDropdownOptions();
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "templates") {
        let params = {
          per_page: "100",
          order_col: "created_at",
        };
        vm.getTeamTemplates({ setListsSettings: false, params })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "contacts") {
        let params = {
          page: vm.teamsSettings[vm.$route.params.team].listsSettings.contacts.pagination.page,
          per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.contacts.pagination.perPage,
          order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.contacts.order.col,
          order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.contacts.order.dir,
        };
        vm.getTeamContacts({
          setListsSettings: true,
          params,
        })
          .then(() => {
            vm.initSort("contacts");
            vm.initShowAs("contacts");
            // vm.initFilters('contacts')
            vm.setDropdownOptions();
            if (vm.contacts.length === 0) vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
            let promises = [];
            vm.contacts.forEach((obj) => {
              if (obj.image) {
                if ((obj.image.status & vm.statiBits.CONVERTED.bit) === vm.statiBits.CONVERTED.bit) {
                  promises.push(
                    vm
                      .getContactImagePreview({
                        file: obj.image.uid,
                        contact: obj.uid,
                        width: "70",
                        height: "70",
                      })
                      .then((res) => {
                        vm.currentContactImagesPreviews.push({
                          uid: obj.uid,
                          url: res,
                        });
                      })
                  );
                }
              }
            });
            Promise.all(promises)
              .then(() => {
                vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
              })
              .catch(() => {
                vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
              });
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "forms") {
        vm.getForms({ customLoading: true })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch((err) => {
            console.log(err);
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "imports") {
        vm.sortImports("", "")
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch((err) => {
            console.log(err);
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "developer") {
        vm.getUserAccessTokens()
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch((err) => {
            console.log(err);
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else {
        vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
      }
    },
    setActiveTab(slug) {
      switch (slug) {
        case this.$t("menus.account").replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("Settings", { tab: "account" });
        case this.$t("menus.team").replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("Settings", { tab: "team" });
        case this.$t("menus.contacts").replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("Settings", { tab: "contacts" });
        case this.$t("menus.templates").replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("Settings", { tab: "templates" });
        case this.$t("menus.forms").replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("Settings", { tab: "forms" });
        case this.$t("menus.imports").replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("Settings", { tab: "imports" });
        case this.$t("menus.developer").replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("Settings", { tab: "developer" });
      }
    },
    getActiveTab() {
      switch (this.$route.params.tab) {
        case "account":
          return this.$t("menus.account").replace(/\s+/g, "-").toLowerCase();
        case "team":
          return this.$t("menus.team").replace(/\s+/g, "-").toLowerCase();
        case "contacts":
          return this.$t("menus.contacts").replace(/\s+/g, "-").toLowerCase();
        case "templates":
          return this.$t("menus.templates").replace(/\s+/g, "-").toLowerCase();
        case "forms":
          return this.$t("menus.forms").replace(/\s+/g, "-").toLowerCase();
        case "imports":
          return this.$t("menus.imports").replace(/\s+/g, "-").toLowerCase();
        case "developer":
          return this.$t("menus.developer").replace(/\s+/g, "-").toLowerCase();
      }
    },
    setAccountModels() {
      this.firstName = this.teams[this.$route.params.team].account.first_name;
      this.lastName = this.teams[this.$route.params.team].account.last_name;
      this.notificationsSilenced = this.teams[this.$route.params.team].account.notifications_silenced;
      this.notificationType = this.teams[this.$route.params.team].account.notification_emails;
      this.timezone = this.$t("timezones").find((obj) => {
        return obj.value === this.teams[this.$route.params.team].account.timezone;
      });
    },
    sortImports(col, dir) {
      var params = {};
      if (this.teamsSettings[this.$route.params.team].listsSettings.imports) {
        params = {
          search: this.searchQuery,
          page: this.teamsSettings[this.$route.params.team].listsSettings.imports.pagination.page,
          per_page: this.teamsSettings[this.$route.params.team].listsSettings.imports.pagination.perPage,
          order_col: col,
          order_dir: dir,
          import_type: "",
        };
      }
      return this.getImports({ setListsSettings: true, params: params });
    },
    changeImportsPage(page, perPage) {
      const params = {
        search: "",
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.imports.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.imports.order.dir,
        import_type: "",
      };
      this.getImports({ setListsSettings: true, params: params });
    },
    sortTemplates(col, dir) {
      const params = {
        search: this.searchQuery,
        page: this.teamsSettings[this.$route.params.team].listsSettings.templates.pagination.page,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.templates.pagination.perPage,
        order_col: col,
        order_dir: dir,
      };
      this.getTemplates(params);
    },
    changeTemplatesPage(page, perPage) {
      const params = {
        search: this.searchQuery,
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.templates.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.templates.order.dir,
      };
      this.getTemplates(params);
    },
    setTemplatesFilters() {
      const params = {
        search: this.searchQuery,
        page: 1,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.templates.pagination.perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.templates.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.templates.order.dir,
      };
      this.getTemplates(params);
      this.$eventbus.$emit("closeAllDropdowns");
    },
    getTemplates(params) {
      this.filterDropdown[0].options.forEach((option) => {
        if (option.active && option.switch && option.switch.name && !option.select) {
          params[option.switch.name] = option.switch.model;
        }
        if (option.active && option.select && !option.select.custom) {
          params[option.select.name] = this.transformModelToRequestArray(option.select.model);
        }
      });
      this.getTeamTemplates({
        setListsSettings: true,
        params,
      }).then(() => {
        this.initSort("templates");
      });
    },
    openTemplateBuilder(template, preview) {
      this.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      this.getTeamTemplateBuilderSession({
        params: { template },
        data: { return_url: window.location.href, preview: preview },
      })
        .then(() => {
          if (this.templateBuilderSession.is_locked) {
            this.$snotify.error(
              this.$t("toasts.builder.locked", {
                user: this.$h.formatName(this.templateBuilderSession.lock.user, true),
              }),
              this.$t("toasts.error"),
              {
                timeout: 0,
                icon: this.$errorIcon,
              }
            );
            this.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          } else if (this.templateBuilderSession.is_seeding) {
            this.$snotify.error(this.$t("toasts.builder.seeding"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
            this.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          } else {
            location.href = this.templateBuilderSession.builder;
          }
        })
        .catch(() => {
          this.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        });
    },
    duplicateTemplate(template) {
      let vm = this;

      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      setTimeout(() => {
        vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
      }, 20000);

      const payload = {
        apiMethod: "duplicate",
        params: {
          template: template.uid,
        },
      };

      vm.templateApiRequest(payload)
        .then(() => {
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        })
        .catch((err) => {
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          console.log("error: ", err);
        });
    },
    sortContacts(col, dir) {
      const params = {
        search: this.searchQuery,
        page: this.teamsSettings[this.$route.params.team].listsSettings.contacts.pagination.page,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.contacts.pagination.perPage,
        order_col: col,
        order_dir: dir,
      };
      this.getContacts(params);
    },
    changeContactsPage(page, perPage) {
      const params = {
        search: this.searchQuery,
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.dir,
      };
      this.getContacts(params);
    },
    // setContactsFilters () {
    //   const params = {
    //     search: this.searchQuery,
    //     page: 1,
    //     per_page: this.teamsSettings[this.$route.params.team].listsSettings.contacts.pagination.perPage,
    //     order_col: this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.col,
    //     order_dir: this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.dir
    //   }
    //   this.getContacts(params)
    //   this.$eventbus.$emit('closeAllDropdowns')
    // },
    getContacts(params) {
      const vm = this;
      // this.filterDropdown[0].options.forEach((option) => {
      //   if (option.active && option.switch && option.switch.name && !option.select) params[option.switch.name] = option.switch.model
      //   if (option.active && option.switch && option.switch.name && option.select) {
      //     option.switch.model ? params[option.switch.name[0]] = this.transformModelToRequestArray(option.select.model)
      //       : params[option.switch.name[1]] = this.transformModelToRequestArray(option.select.model)
      //   }
      // })
      vm.getTeamContacts({
        setListsSettings: true,
        params,
      }).then(() => {
        vm.initSort("contacts");
        vm.contacts.forEach((obj) => {
          if (obj.image) {
            if ((obj.image.status & vm.statiBits.CONVERTED.bit) === vm.statiBits.CONVERTED.bit) {
              vm.getContactImagePreview({
                file: obj.image.uid,
                contact: obj.uid,
                width: "70",
                height: "70",
              }).then((res) => {
                vm.currentContactImagesPreviews.push({
                  uid: obj.uid,
                  url: res,
                });
              });
            }
          }
        });
      });
    },
    getFilePreview(uid) {
      const o = this.currentContactImagesPreviews.find((obj) => {
        return obj.uid === uid;
      });
      return o ? o.url : "";
    },
    toggleFirstName() {
      if (this.editFirstName) {
        this.firstNameIsLoading = true;
        let data = {
          first_name: this.firstName,
        };
        this.$validator.validateAll("firstName").then((result) => {
          if (result) {
            this.editAuthAccount(data)
              .then(() => {
                this.getAuthAccount({
                  team: this.$router.currentRoute.params.team,
                })
                  .then(() => {
                    this.$snotify.success(this.$t("toasts.editedAccount.success"), this.$t("toasts.success"), {
                      icon: this.$successIcon,
                    });
                    this.editFirstName = !this.editFirstName;
                    this.firstNameIsLoading = false;
                  })
                  .catch((err) => {
                    if (err.response && !err.response.data.error.custom) {
                      this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                        timeout: 0,
                        icon: this.$errorIcon,
                      });
                    }
                    this.editFirstName = !this.editFirstName;
                    this.firstNameIsLoading = false;
                  });
              })
              .catch((err) => {
                if (err.response && !err.response.data.error.custom) {
                  this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                    timeout: 0,
                    icon: this.$errorIcon,
                  });
                }
                this.editFirstName = !this.editFirstName;
                this.firstNameIsLoading = false;
              });
          } else {
            this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
            this.firstNameIsLoading = false;
          }
        });
      } else {
        this.editFirstName = true;
      }
    },
    toggleLastName() {
      if (this.editLastName) {
        this.lastNameIsLoading = true;
        let data = {
          last_name: this.lastName,
        };
        this.$validator.validateAll("lastName").then((result) => {
          if (result) {
            this.editAuthAccount(data)
              .then(() => {
                this.getAuthAccount({
                  team: this.$router.currentRoute.params.team,
                })
                  .then(() => {
                    this.$snotify.success(this.$t("toasts.editedAccount.success"), this.$t("toasts.success"), {
                      icon: this.$successIcon,
                    });
                    this.editLastName = !this.editLastName;
                    this.lastNameIsLoading = false;
                  })
                  .catch((err) => {
                    if (err.response && !err.response.data.error.custom) {
                      this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                        timeout: 0,
                        icon: this.$errorIcon,
                      });
                    }
                    this.editLastName = !this.editLastName;
                    this.lastNameIsLoading = false;
                  });
              })
              .catch((err) => {
                if (err.response && !err.response.data.error.custom) {
                  this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                    timeout: 0,
                    icon: this.$errorIcon,
                  });
                }
                this.editLastName = !this.editLastName;
                this.lastNameIsLoading = false;
              });
          } else {
            this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
            this.lastNameIsLoading = false;
          }
        });
      } else {
        this.editLastName = true;
      }
    },
    toggleAccountLocale() {
      if (this.editAccountLocale) {
        this.accountLocaleIsLoading = true;
        let data = {
          locale: this.accountLocale ? this.accountLocale.value : null,
        };
        this.$validator.validateAll("locale").then((result) => {
          if (result) {
            this.editAuthAccount(data)
              .then(() => {
                this.getAuthAccount({
                  team: this.$router.currentRoute.params.team,
                })
                  .then(() => {
                    this.$snotify.success(this.$t("toasts.editedAccount.success"), this.$t("toasts.success"), {
                      icon: this.$successIcon,
                    });
                    this.editAccountLocale = !this.editAccountLocale;
                    this.accountLocaleIsLoading = false;
                    this.$initLocale(this.accountLocale.value);
                    this.$eventbus.$emit("refreshAppData");
                    this.setTabs();
                  })
                  .catch((err) => {
                    if (err.response && !err.response.data.error.custom) {
                      this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                        timeout: 0,
                        icon: this.$errorIcon,
                      });
                    }
                    this.editAccountLocale = !this.editAccountLocale;
                    this.accountLocaleIsLoading = false;
                  });
              })
              .catch((err) => {
                if (err.response && !err.response.data.error.custom) {
                  this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                    timeout: 0,
                    icon: this.$errorIcon,
                  });
                }
                this.editAccountLocale = !this.editAccountLocale;
                this.accountLocaleIsLoading = false;
              });
          } else {
            this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
            this.accountLocaleIsLoading = false;
          }
        });
      } else {
        this.editAccountLocale = true;
      }
    },
    toggleTimezone() {
      if (this.editTimezone) {
        this.timezoneIsLoading = true;
        let data = {
          timezone: this.timezone ? this.timezone.value : "",
        };
        this.$validator.validateAll("timezone").then((result) => {
          if (result) {
            this.editAuthAccount(data)
              .then(() => {
                this.getAuthAccount({
                  team: this.$router.currentRoute.params.team,
                })
                  .then(() => {
                    this.$snotify.success(this.$t("toasts.editedAccount.success"), this.$t("toasts.success"), {
                      icon: this.$successIcon,
                    });
                    this.editTimezone = !this.editTimezone;
                    this.timezoneIsLoading = false;
                  })
                  .catch((err) => {
                    if (err.response && !err.response.data.error.custom) {
                      this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                        timeout: 0,
                        icon: this.$errorIcon,
                      });
                    }
                    this.editTimezone = !this.editTimezone;
                    this.timezoneIsLoading = false;
                  });
              })
              .catch((err) => {
                if (err.response && !err.response.data.error.custom) {
                  this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                    timeout: 0,
                    icon: this.$errorIcon,
                  });
                }
                this.editTimezone = !this.editTimezone;
                this.timezoneIsLoading = false;
              });
          } else {
            this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
            this.timezoneIsLoading = false;
          }
        });
      } else {
        this.editTimezone = true;
      }
    },
    toggleNotificationsSilenced() {
      let data = {
        notifications_silenced: this.notificationsSilenced,
      };
      this.editAuthAccount(data)
        .then(() => {
          this.$snotify.success(this.$t("toasts.editedAccount.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
    toggleNotificationType() {
      if (this.editNotificationType) {
        this.notificationTypeIsLoading = true;
        let data = {
          notification_emails: this.notificationType,
        };
        this.editAuthAccount(data)
          .then(() => {
            this.getAuthAccount({
              team: this.$router.currentRoute.params.team,
            })
              .then(() => {
                this.$snotify.success(this.$t("toasts.editedAccount.success"), this.$t("toasts.success"), {
                  icon: this.$successIcon,
                });
                this.editNotificationType = !this.editNotificationType;
                this.notificationTypeIsLoading = false;
              })
              .catch((err) => {
                if (err.response && !err.response.data.error.custom) {
                  this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                    timeout: 0,
                    icon: this.$errorIcon,
                  });
                }
                this.editNotificationType = !this.editNotificationType;
                this.notificationTypeIsLoading = false;
              });
          })
          .catch((err) => {
            if (err.response && !err.response.data.error.custom) {
              this.$snotify.error(this.$t("toasts.editedAccount.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            }
            this.editNotificationType = !this.editNotificationType;
            this.notificationTypeIsLoading = false;
          });
      } else {
        this.editNotificationType = true;
      }
    },
    setTabs() {
      this.tabs = [
        this.$t("menus.account"),
        this.$t("menus.team"),
        this.$t("menus.contacts"),
        this.$t("menus.templates"),
        this.$t("menus.imports"),
        this.$t("menus.developer"),
      ];
    },
    showDeleteModal(uid) {
      this.currentDeleteUid = uid;
      this.$modal.show("delete-contact-modal");
    },
    deleteContactModalHandler(uid) {
      this.currentDeleteUid = null;
      this.$modal.hide("delete-contact-modal");
      this.deleteContact({ contact: uid })
        .then(() => {
          this.getTeamContacts({
            setListsSettings: true,
            params: {
              page: this.teamsSettings[this.$route.params.team].listsSettings.clients.page,
              per_page: this.teamsSettings[this.$route.params.team].listsSettings.clients.perPage,
              order_col: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.col,
              order_dir: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir,
            },
          }).then(() => {
            this.$snotify.success(this.$t("toasts.deleteContact.success"), this.$t("toasts.success"), {
              icon: this.$successIcon,
            });
          });
        })
        .catch((err) => {
          this.$modal.hide("delete-contact-modal");
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.deleteContact.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
    toggleCustomField(customField, index) {
      if (this.editCustomField[index]) {
        this.$set(this.customFieldIsLoading, index, true);
        let custom = {};
        if (this.teams[this.$route.params.team].accountCustomFields[index].type === "select") {
          custom[index] = [this.customFieldValue[index].value];
        } else if (this.teams[this.$route.params.team].accountCustomFields[index].type === "multiselect") {
          custom[index] = [];
          this.customFieldValue[index].forEach((val) => {
            custom[index].push(val.value);
          });
        } else {
          custom[index] = this.customFieldValue[index];
        }
        let data = {
          custom,
        };
        this.editAuthAccount(data)
          .then(() => {
            this.getAuthAccount({
              team: this.$router.currentRoute.params.team,
            });
            this.$snotify.success(this.$t("toasts.editedProject.success"), this.$t("toasts.success"), {
              icon: this.$successIcon,
            });
            this.$set(this.editCustomField, index, false);
            this.$set(this.customFieldIsLoading, index, false);
          })
          .catch((err) => {
            if (err.response && !err.response.data.error.custom) {
              this.$snotify.error(this.$t("toasts.editedProject.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            }
            this.$set(this.customFieldIsLoading, index, false);
          });
      } else {
        this.$set(this.editCustomField, index, true);
      }
    },
    toggleTeamName() {
      if (this.teams[this.$route.params.team].account.role.includes("owner")) {
        if (this.editTeamName) {
          this.teamNameIsLoading = true;
          let data = {
            name: this.teamName,
          };
          this.$validator.validateAll("teamname").then((result) => {
            if (result) {
              this.editTeam({ customLoading: true, data })
                .then(() => {
                  this.getAuthAccount({
                    team: this.$router.currentRoute.params.team,
                  })
                    .then(() => {
                      this.$snotify.success(this.$t("toasts.editedTeam.success"), this.$t("toasts.success"), {
                        icon: this.$successIcon,
                      });
                      this.editTeamName = !this.editTeamName;
                      this.teamNameIsLoading = false;
                    })
                    .catch((err) => {
                      if (err.response && !err.response.data.error.custom) {
                        this.$snotify.error(this.$t("toasts.editedTeam.error"), this.$t("toasts.error"), {
                          timeout: 0,
                          icon: this.$errorIcon,
                        });
                      }
                      this.editTeamName = !this.editTeamName;
                      this.teamNameIsLoading = false;
                    });
                })
                .catch((err) => {
                  if (err.response && !err.response.data.error.custom) {
                    this.$snotify.error(this.$t("toasts.editedTeam.error"), this.$t("toasts.error"), {
                      timeout: 0,
                      icon: this.$errorIcon,
                    });
                  }
                  this.editTeamName = !this.editTeamName;
                  this.teamNameIsLoading = false;
                });
            } else {
              this.$snotify.error(this.$t("toasts.editedTeam.validation"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
              this.teamNameIsLoading = false;
            }
          });
        } else {
          this.editTeamName = true;
        }
      } else {
        this.$h.showSubscriptionErrorModal(this.$modal);
      }
    },
    toggleTeamDomain() {
      if (this.teams[this.$route.params.team].account.role.includes("owner")) {
        if (this.editTeamDomain) {
          this.teamDomainIsLoading = true;
          let data = {
            url: this.teamDomain,
          };
          this.$validator.validateAll("teamdomain").then((result) => {
            if (result) {
              this.editTeam({ customLoading: true, data })
                .then(() => {
                  this.getAuthAccount({
                    team: this.$router.currentRoute.params.team,
                  })
                    .then(() => {
                      this.$snotify.success(this.$t("toasts.editedTeam.success"), this.$t("toasts.success"), {
                        icon: this.$successIcon,
                      });
                      this.editTeamDomain = !this.editTeamDomain;
                      this.teamDomainIsLoading = false;
                    })
                    .catch((err) => {
                      if (err.response && !err.response.data.error.custom) {
                        this.$snotify.error(this.$t("toasts.editedTeam.error"), this.$t("toasts.error"), {
                          timeout: 0,
                          icon: this.$errorIcon,
                        });
                      }
                      this.editTeamDomain = !this.editTeamDomain;
                      this.teamDomainIsLoading = false;
                    });
                })
                .catch((err) => {
                  if (err.response && !err.response.data.error.custom) {
                    this.$snotify.error(this.$t("toasts.editedTeam.error"), this.$t("toasts.error"), {
                      timeout: 0,
                      icon: this.$errorIcon,
                    });
                  }
                  this.editTeamDomain = !this.editTeamDomain;
                  this.teamDomainIsLoading = false;
                });
            } else {
              this.$snotify.error(this.$t("toasts.editedTeam.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
              this.teamDomainIsLoading = false;
            }
          });
        } else {
          this.editTeamDomain = true;
        }
      } else {
        this.$h.showSubscriptionErrorModal(this.$modal);
      }
    },
    getDeleteTeamPin() {
      if (this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")) {
        const vm = this;
        vm.postDeleteTeam()
          .then(() => {
            vm.$snotify.success(vm.$t("toasts.getDeleteTeamPin.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
          })
          .catch((err) => {
            if (err.response && !err.response.data.error.custom) {
              this.$snotify.error(this.$t("toasts.getDeleteTeamPin.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            }
          });
      } else {
        this.$h.showSubscriptionErrorModal(this.$modal);
      }
    },
    deleteThisTeam() {
      if (this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            const data = {
              pin: this.pin,
              password: this.password,
            };
            this.deleteTeam(data)
              .then(() => {
                this.$snotify.success(this.$t("toasts.deleteTeam.success"), this.$t("toasts.success"), {
                  icon: this.$successIcon,
                });
                this.logout();
              })
              .catch((err) => {
                if (err.response && !err.response.data.error.custom) {
                  this.$snotify.error(this.$t("toasts.deleteTeam.error"), this.$t("toasts.error"), {
                    timeout: 0,
                    icon: this.$errorIcon,
                  });
                }
              });
          } else {
            this.$snotify.error(this.$t("toasts.deleteTeam.validation"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
      } else {
        this.$h.showSubscriptionErrorModal(this.$modal);
      }
    },
    openCreateTeamMemberModal() {
      this.firstname = "";
      this.lastname = "";
      this.email = "";
      this.$modal.show("create-member");
    },
    createTeamMember(bool) {
      const vm = this;
      const data = {
        first_name: vm.firstname,
        last_name: vm.lastname,
        email: vm.email,
        gender: vm.gender ? vm.gender.value : "",
      };
      vm.$validator.validateAll("createTeamMember").then((result) => {
        if (result) {
          if (!bool) vm.$modal.hide("create-member");
          vm.createUserModalLoading = true;
          vm.createUser(data)
            .then(() => {
              let params = {
                page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.page,
                per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.perPage,
                order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.col,
                order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.dir,
              };
              console.log("CREATED");
              this.loadUsers(params);
              this.firstname = "";
              this.lastname = "";
              this.email = "";
              this.gender = null;
              vm.$snotify.success(vm.$t("toasts.createAndInviteUser.success"), vm.$t("toasts.success"), {
                icon: vm.$successIcon,
              });
              vm.createUserModalLoading = false;
            })
            .catch((err) => {
              console.log("err", err.response);
              if (err.response && err.response.status === 403) {
                this.$modal.show("error-team-modal");
              }
              if (err.response && !err.response.data.error.custom) {
                vm.$snotify.error(vm.$t("toasts.createAndInviteUser.error"), vm.$t("toasts.error"), {
                  timeout: 0,
                  icon: vm.$errorIcon,
                });
              }
              vm.createUserModalLoading = false;
            });
        }
      });
    },
    setTeamMembersDropdownOptions(user) {
      let options = [];
      return new Promise((resolve, reject) => {
        if ((user.status & this.usersStati.ACTIVE.bit) === this.usersStati.ACTIVE.bit) {
          this.getUserSubscription({ customLoading: true, user: user.uid })
            .then((res) => {
              if (res.subscribed) {
                options = [
                  {
                    label: this.$t("actions.removeSubscription"),
                    method: (user) => {
                      this.removeUserSubscription(user.uid);
                    },
                  },
                  {
                    label: this.$t("actions.deactivate"),
                    method: (user) => {
                      this.deactivateUser(user.uid);
                    },
                  },
                ];
              } else if (user.uid !== this.teams[this.$route.params.team].account.uid) {
                options = [
                  {
                    label: this.$t("actions.addSubscription"),
                    method: (user) => {
                      this.addUserSubscription(user.uid);
                    },
                  },
                  {
                    label: this.$t("actions.deactivate"),
                    method: (user) => {
                      this.deactivateUser(user.uid);
                    },
                  },
                ];
              }
              if (
                this.teams[this.$route.params.team].account.role.includes("admin") ||
                this.teams[this.$route.params.team].account.role.includes("owner")
              ) {
                if (this.teamCan("user-roles")) {
                  options.push({
                    label: this.$t("actions.manageRole"),
                    method: (user) => {
                      this.manageRoles(user.uid);
                    },
                  });
                } else {
                  options.push({
                    label: this.$t("actions.manageRole"),
                    disabled: true,
                    disabledHandler: true,
                    icon: "Icon=lock.svg",
                    showAlwaysIcon: true,
                    method: () => {
                      this.$h.showSubscriptionErrorModal(this.$modal);
                    },
                  });
                }
              }
              resolve([
                {
                  options: options,
                },
              ]);
            })
            .catch((err) => {
              reject(err);
            });
        } else if (
          (user.status & this.usersStati.ACTIVE.bit) !== this.usersStati.ACTIVE.bit &&
          (user.status & this.usersStati.INVITED.bit) !== this.usersStati.INVITED.bit
        ) {
          options = [
            {
              label: this.$t("actions.activate"),
              method: (user) => {
                this.activateUser(user.uid);
              },
            },
          ];
          resolve([
            {
              options: options,
            },
          ]);
        } else {
          options = [
            {
              label: this.$t("actions.resendInvitation"),
              method: (user) => {
                this.resendInvitation(user.uid);
              },
            },
            {
              label: this.$t("actions.delete"),
              method: (user) => {
                this.showDeleteTeamMemberModal(user.uid);
              },
              color: "text-danger",
            },
          ];
          resolve([
            {
              options: options,
            },
          ]);
        }
      });
    },
    loadUsers(params) {
      this.filterDropdown[0].options.forEach((option) => {
        if (option.active && option.switch && option.switch.name && !option.select) {
          params[option.switch.name] = option.switch.model;
        }
      });
      console.log("LAOD USERS");
      this.getUsers({
        setListsSettings: true,
        params,
      })
        .then(() => {
          this.initSort("users");
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    sortUsers(col, dir) {
      const params = {
        search: this.searchQuery,
        page: this.teamsSettings[this.$route.params.team].listsSettings.users.pagination.page,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.users.pagination.perPage,
        order_col: col,
        order_dir: dir,
      };
      this.loadUsers(params);
    },
    changeUsersPage(page, perPage) {
      const params = {
        search: this.searchQuery,
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.users.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.users.order.dir,
      };
      this.loadUsers(params);
    },
    setUsersFilters() {
      const params = {
        search: this.searchQuery,
        page: 1,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.users.pagination.perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.users.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.users.order.dir,
      };
      this.loadUsers(params);
      this.$eventbus.$emit("closeAllDropdowns");
    },
    showDeleteTeamMemberModal(uid) {
      this.currentDeleteTeamMember = uid;
      this.$modal.show("delete-member-modal");
    },
    deleteTeamMemberModalHandler() {
      const vm = this;
      vm.$modal.hide("delete-member-modal");
      vm.deleteUser({ user: vm.currentDeleteTeamMember })
        .then(() => {
          this.currentDeleteTeamMember = null;
          let params = {
            page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.page,
            per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.perPage,
            order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.col,
            order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.dir,
          };
          vm.loadUsers(params);
          vm.$snotify.success(vm.$t("toasts.deleteUser.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            vm.$snotify.error(vm.$t("toasts.deleteUser.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          }
        });
    },
    resendInvitation(uid) {
      const vm = this;
      vm.inviteUser({ user: uid })
        .then(() => {
          let params = {
            page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.page,
            per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.perPage,
            order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.col,
            order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.dir,
          };
          this.loadUsers(params);
          vm.$snotify.success(vm.$t("toasts.inviteUser.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            vm.$snotify.error(vm.$t("toasts.inviteUser.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          }
        });
    },
    setRole(value) {
      this.role = value;
    },
    manageRoles(uid) {
      this.currentManageRolesMember = uid;
      this.$modal.show("manage-role");
    },
    saveRoles() {
      const vm = this;
      if (this.role !== "") {
        vm.editUserRoles({
          params: { user: vm.currentManageRolesMember },
          data: { role: this.role },
        })
          .then(() => {
            vm.$snotify.success(vm.$t("toasts.manageRole.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
            vm.$modal.hide("manage-role");
            let params = {
              page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.page,
              per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.perPage,
              order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.col,
              order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.dir,
            };
            vm.loadUsers(params);
          })
          .catch((err) => {
            if (err.response && !err.response.data.error.custom) {
              vm.$snotify.error(vm.$t("toasts.manageRole.error"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            }
          });
      } else {
        this.errors.add({
          field: "role",
          msg: "Please choose a role",
        });
        vm.$snotify.error(vm.$t("toasts.manageRole.validation"), vm.$t("toasts.error"), {
          timeout: 0,
          icon: vm.$errorIcon,
        });
      }
    },
    addUserSubscription(uid) {
      this.postUserSubscription({ customLoading: true, user: uid })
        .then(() => {
          this.$snotify.success(this.$t("toasts.setSubscription.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.setSubscription.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
    removeUserSubscription(uid) {
      this.deleteUserSubscription({ customLoading: true, user: uid })
        .then(() => {
          this.$snotify.success(this.$t("toasts.deleteSubscription.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.deleteSubscription.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
    activateUser(user) {
      const vm = this;
      let data = {
        status: { ACTIVE: true },
      };
      vm.editUser({ params: { user: user }, data })
        .then(() => {
          let params = {
            page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.page,
            per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.perPage,
            order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.col,
            order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.dir,
          };
          this.loadUsers(params);
          vm.$snotify.success(vm.$t("toasts.activateUser.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            vm.$snotify.error(vm.$t("toasts.activateUser.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          }
        });
    },
    deactivateUser(user) {
      const vm = this;
      let data = {
        status: { ACTIVE: false },
      };
      vm.editUser({ params: { user: user }, data })
        .then(() => {
          let params = {
            page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.page,
            per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.users.pagination.perPage,
            order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.col,
            order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.users.order.dir,
          };
          this.loadUsers(params);
          vm.$snotify.success(vm.$t("toasts.deactivateUser.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            vm.$snotify.error(vm.$t("toasts.deactivateUser.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          }
        });
    },
    initChargebee() {
      let site;
      this.teams &&
      this.teams[this.$route.params.team] &&
      this.teams[this.$route.params.team].account &&
      this.teams[this.$route.params.team].account.team.cb_site
        ? (site = this.teams[this.$route.params.team].account.team.cb_site)
        : (site = "");
      try {
        this.chargebeeInstance = window.Chargebee.getInstance();
      } catch (err) {
        this.chargebeeInstance = window.Chargebee.init({
          site,
        });
        this.chargebeeInstance = window.Chargebee.getInstance();
      }
      this.chargebeeInstance.setPortalCallbacks({
        loaded: () => {
          console.log("Chargebee Portal loaded");
        },
        close: () => {
          console.log("Chargebee Portal closed");
          this.chargebeeInstance.logout();
          this.getTeamSubscription({ team: this.$route.params.team }).then(() => {
            this.getAuthAccount({ team: this.$route.params.team });
          });
        },
        visit: (value) => {
          console.log("Chargebee Portal visited", value);
        },
      });
    },
    openBilling() {
      if (this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")) {
        this.postTeamSubscription({ team: this.$route.params.team })
          .then((res) => {
            this.chargebeeInstance.setPortalSession(res);
            let cbPortal = this.chargebeeInstance.createChargebeePortal();
            cbPortal.open();
          })
          .catch(() => {
            this.$snotify.error(this.$t("toasts.defaultError.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          });
      } else {
        this.$h.showSubscriptionErrorModal(this.$modal);
      }
    },
    getTokens() {
      const vm = this;
      vm.getUserAccessTokens();
    },
    createNewToken() {
      if (!this.showCreatedToken) {
        const vm = this;
        const data = {
          name: vm.tokenName,
        };
        vm.$validator.validateAll("createUserAccessToken").then((result) => {
          if (result) {
            vm.createUserAccessToken(data)
              .then((res) => {
                vm.lastCreatedToken = res;
                vm.showCreateToken = false;
                vm.showCreatedToken = true;
                this.$snotify.success(this.$t("settings.dev.toasts.create.success"), this.$t("toasts.success"), {
                  icon: this.$successIcon,
                });
              })
              .catch(() => {
                vm.showCreateToken = false;
                this.$snotify.error(this.$t("settings.dev.toasts.create.error"), this.$t("toasts.error"), {
                  timeout: 0,
                  icon: this.$errorIcon,
                });
              });
          } else {
            this.$snotify.error(this.$t("settings.dev.toasts.create.validation"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
      }
    },
    setEditUserAccessToken(value) {
      console.log("setEditUserAccessToken", value);
      this.editToken = value;
      this.editTokenName = value.name;
      this.showEditToken = true;
    },
    updateToken() {
      const vm = this;
      const data = {
        name: vm.editTokenName,
      };
      const params = {
        token: vm.editToken.access_key,
      };
      vm.$validator.validateAll("editUserAccessToken").then((result) => {
        if (result) {
          vm.editUserAccessToken({ data, params })
            .then(() => {
              vm.showEditToken = false;
              vm.getTokens();
              this.$snotify.success(this.$t("settings.dev.toasts.edit.success"), this.$t("toasts.success"), {
                icon: this.$successIcon,
              });
            })
            .catch((err) => {
              console.log(err);
              vm.showEditToken = false;
              this.$snotify.error(this.$t("settings.dev.toasts.edit.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            });
        } else {
          this.$snotify.error(this.$t("settings.dev.toasts.edit.validation"), this.$t("toasts.error"), {
            timeout: 0,
            icon: this.$errorIcon,
          });
        }
      });
    },
    openDeleteTokenModal(value) {
      this.currentDeleteToken = value;
      this.$modal.show("delete-token-modal");
    },
    deleteTokenModalHandler() {
      const vm = this;
      vm.deleteUserAccessToken({ token: vm.currentDeleteToken.access_key })
        .then(() => {
          vm.$modal.hide("delete-token-modal");
          vm.currentDeleteToken = {};
          vm.getTokens();
          this.$snotify.success(this.$t("settings.dev.toasts.delete.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          console.log(err);
          vm.$modal.hide("delete-token-modal");
          vm.currentDeleteToken = {};
          this.$snotify.error(this.$t("settings.dev.toasts.delete.error"), this.$t("toasts.error"), {
            timeout: 0,
            icon: this.$errorIcon,
          });
        });
    },
    copyToClipboard(value, key) {
      clipboard.writeText(value);
      this.$snotify.success(this.$t("settings.dev.toasts.copy." + key), this.$t("toasts.success"), {
        icon: this.$successIcon,
      });
    },
    returnToTokenList() {
      this.getTokens();
      this.tokenName = "";
      this.showCreateToken = false;
      this.showCreatedToken = false;
      this.showEditToken = false;
      this.lastCreatedToken = {};
    },
    sortFormSubmissions(col, dir) {
      const params = {
        search: this.searchQuery,
        page: this.teamsSettings[this.$route.params.team].listsSettings.templates.pagination.page,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.templates.pagination.perPage,
        order_col: col,
        order_dir: dir,
      };
      this.getSubmissions(params);
    },
    changeFormSubmissionsPage(page, perPage) {
      const params = {
        search: this.searchQuery,
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.templates.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.templates.order.dir,
      };
      this.getSubmissions(params);
    },
    setFormSubmissionsFilters() {
      const params = {
        search: this.searchQuery,
        page: 1,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.templates.pagination.perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.templates.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.templates.order.dir,
      };
      this.getSubmissions(params);
      this.$eventbus.$emit("closeAllDropdowns");
    },
    getSubmissions(params) {
      this.filterDropdown[0].options.forEach((option) => {
        if (option.active && option.switch && option.switch.name && !option.select) {
          params[option.switch.name] = option.switch.model;
        }
        if (option.active && option.select && !option.select.custom) {
          params[option.select.name] = this.transformModelToRequestArray(option.select.model);
        }
      });
      this.getFormSubmissions({
        formFieldset: this.$route.params.form,
        setListsSettings: true,
        params,
      }).then(() => {
        this.initSort("formSubmissions");
      });
    },
    setDropdownData(template) {
      let options = [];
      if (template && !template.template_builder_disabled) {
        options.push({
          name: this.$t("actions.editTemplate"),
          method: (template) => {
            this.openTemplateBuilder(template.uid, false);
          },
        });
      }
      options.push({
        name: this.$t("actions.duplicateTemplate"),
        method: (template) => {
          this.duplicateTemplate(template);
        },
      });
      if (template && template.is_deletable) {
        options.push({
          name: this.$t("actions.deleteTemplate"),
          method: (template) => {
            this.showDeleteTemplateModal(template);
          },
          class: "text-v2-error-500",
        });
      }
      return options;
    },
    showDeleteTemplateModal(template) {
      this.currentDeleteTemplate = template;
      this.$modal.show("delete-template-modal");
    },
    deleteTemplateModalHandler() {
      const vm = this;
      const payload = {
        apiMethod: "deleteTemplate",
        params: {
          template: vm.currentDeleteTemplate.uid,
        },
      };
      vm.$modal.hide("delete-template-modal");
      vm.currentDeleteTemplate = {};
      vm.templateApiRequest(payload)
        .then(() => {
          let params = {
            per_page: "100",
            order_col: "created_at",
          };
          vm.getTeamTemplates({ setListsSettings: false, params })
            .then(() => {
              vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
            })
            .catch(() => {
              vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
            });
          this.$snotify.success(this.$t("settings.templates.toasts.delete.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          console.log(err);
          this.$snotify.error(this.$t("settings.templates.toasts.delete.error"), this.$t("toasts.error"), {
            timeout: 0,
            icon: this.$errorIcon,
          });
        });
    },
    exportFormSubmission(form) {
      const data = { formFieldset: form.uid, name: form.name };
      this.exportFormResponses(data);
    },
  },
  computed: {
    isFormsEnabled() {
      return (
        this.teams[this.$route.params.team].account && this.teams[this.$route.params.team].account.team.attributes.forms
      );
    },
    filteredAccountCustomFields() {
      return Object.fromEntries(
        Object.entries(this.teams[this.$route.params.team].accountCustomFields).filter(
          ([, field]) => field.visible === true
        )
      );
    },
    ...mapGetters({
      teams: "auth_get_teams",
      statiBits: "global_get_fileStatiBits",
      teamsSettings: "global_get_teams_settings",
      showTips: "global_get_show_tips",
      templates: "templates_get_templates",
      teamLanguages: "teams_get_languages",
      teamThemes: "teams_get_themes",
      customLoading: "global_is_custom_loading",
      templateBuilderSession: "templates_get_template_builder_session",
      contacts: "teams_get_contacts",
      imports: "import_get_imports",
      importsMeta: "import_get_imports_meta",
      users: "user_get_users",
      usersStati: "user_get_users_stati",
      userAccessTokens: "user_get_user_access_tokens",
      forms: "forms_get_forms",
      currentForm: "forms_get_current_form",
      formSubmissions: "forms_get_form_submissions",
      clients: "clients_get_client_list",
      projects: "projects_get_project_list",
    }),
  },
};
</script>
